import { render, staticRenderFns } from "./BemInput.vue?vue&type=template&id=402daf66&scoped=true"
import script from "./BemInput.vue?vue&type=script&lang=js"
export * from "./BemInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402daf66",
  null
  
)

export default component.exports